module.exports = __webpack_public_path__ + "img/insurance company thumb.9e350ef7.png";